import { BaseComponentConfig } from '@interfaces/config/cms-components/base-config';
import { CmsComponentTypeEnum } from '@models/enums';
import { TextMediaBox } from '@interfaces/config';

export namespace NewsTickerItem {
  export const TypeEnum = CmsComponentTypeEnum.NEWS_TICKER_ITEM;

  
  export interface NewsConfig {
    uri: string;
   
    newsTitle:string
  }

  export interface ComponentConfig extends BaseComponentConfig {
    newsItems :NewsConfig[],
 
  }
}
